import React, { PropTypes } from 'react';
import { reduxForm } from 'redux-form';
import { fieldClass } from 'common/semantic/utils';

const validate = values => {
  const errors = {};
  if (!values.title) {
    errors.title = true;
  }

  return errors;
};

class QuestionForm extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.goBack = this.goBack.bind(this);
  }

  goBack(evt) {
    evt.preventDefault();
    this.context.router.goBack();
  }

  render() {
    const { fields: { title }, handleSubmit, submitting } = this.props;

    return (
      <form className="ui form" onSubmit={handleSubmit}>
        <div className={fieldClass(title)}>
          <label>Question</label>
          <input type="text" name="title" placeholder="Titre" {...title} />
        </div>
        <button
          className="ui right floated primary button"
          type="submit"
          disabled={submitting}
        >
          Créer
        </button>
        <button className="ui right floated button" onClick={this.goBack}>
          Annuler
        </button>
      </form>
    );
  }
}

QuestionForm.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default reduxForm({
  form: 'question',
  fields: ['title'],
  validate,
})(QuestionForm);



// WEBPACK FOOTER //
// ./src/modules/funnel/components/QuestionForm.js